module.exports = __webpack_public_path__ + "static/media/moxy.c6bade3a.png";